import type { ModuleMigrationDef } from "@kubdee/sdk";

// ============================================================================
// 003_drop_customers — issue #364 (Option D).
//
// Removes the CRM-owned `crm_customers` table introduced by 002 (#359). The
// Doctype Admin pilot proved that custom_data round-trips end-to-end, but
// the decision recorded on #364 is to keep customer data on the existing
// `accounting_partners` table (filtered by `is_customer = 1`) instead of
// maintaining a parallel master table. Migration 0020 on the Drizzle tenant
// schema adds `custom_data` to `accounting_partners` so the customer doctype
// can continue to scope custom field values without an additional table.
//
// Safety:
//   - `DROP INDEX IF EXISTS` + `DROP TABLE IF EXISTS` — idempotent on replay
//     and safe on tenants that never applied 002 for whatever reason.
//   - No data migration is required. `crm_customers` was only ever written
//     by the C2 (#360) pilot route; that route now targets
//     `accounting_partners` directly, so any pilot rows that exist get left
//     behind when the table is dropped. Production tenants have not opted
//     into the pilot yet (see #364 for the audit), so no customer data is
//     at risk.
//   - Upstream `module_migration_log` stamps this key `completed` after
//     first successful run; re-applying is an automatic no-op.
// ============================================================================
export const migration: ModuleMigrationDef = {
  key: "003_drop_customers",
  version: "1.0.0",
  sql: `
DROP INDEX IF EXISTS \`crm_customer_company_idx\`;
DROP TABLE IF EXISTS \`crm_customers\`;
  `.trim(),
};
